<ion-item class="input-select" *transloco="let t">
  <ion-label
    position="stacked"
    [ngStyle]="{ visibility: showLabel ? 'visible' : 'hidden' }"
    >{{ label }}</ion-label
  >
  <ion-select
    justify="start"
    [ngClass]="{
      error: (control && control.invalid && control.touched) || false
    }"
    [placeholder]="placeholder"
    [(ngModel)]="internalValue"
    (blur)="onTouched($event)"
    [cancelText]="t('common.cancel')"
    [multiple]="multiple"
  >
    <ion-select-option *ngFor="let opt of options" [value]="opt.value">{{
      opt.label
    }}</ion-select-option>
  </ion-select>
  <span
    *ngIf="(control && control.invalid && control.touched) || false"
    class="error"
    >{{ error ? error : t('common.required') }}</span
  >
  <span
    *ngIf="!(control && control.invalid && control.touched)"
    [ngStyle]="{
      visibility:
        !(control && control.invalid && control.touched) && caption
          ? 'visible'
          : 'hidden'
    }"
    >{{ caption }}</span
  >
</ion-item>
